import { SelectInputProps } from "@/types/components/SelectInputProps";
import { Icon } from "@iconify/react/dist/iconify.js";
import { ChangeEvent, useEffect, useState } from "react";
import ReactSelect from "react-select";

const SelectInput = ({
    options,
    setData,
    dataKey = "specialization_id",
    defaultValue = "",
    defaultLabel = "",
    className = "",
    label,
    questionMark = false,
    requiredMark = false,
    labelClass = "",
}: {
    setData: (key: string, value: any) => void;
    dataKey?: string;
    options: SelectInputProps[];
    className?: string;
    label: string;
    questionMark?: boolean;
    defaultValue?: string;
    defaultLabel?: string;
    requiredMark?: boolean;
    labelClass?: string;
}) => {
    const [currentActive, setCurrentActive] = useState<string>(defaultValue);

    useEffect(() => {
        if (defaultValue !== "") {
            setData(dataKey, defaultValue);
        }
    }, [defaultValue, options]);

    const handleReactSelectChange = (e: any) => {
        if (e != null) {
            setData(dataKey, e.value);
            setCurrentActive(e.value);
        } else {
            setData(dataKey, "0");
            setCurrentActive("");
        }
    };

    let mergedLabelClass = `text-12 leading-16 text-accordorange tracking-[0.18px] absolute top-2 left-4 z-30 ${labelClass}`;

    return (
        <div
            className={`react-select-input-container relative ${questionMark ? "maxMd:max-w-[calc(100%_-_16px)]" : ""} `}
        >
            <label htmlFor="react-select-input" className={mergedLabelClass}>
                {label}
            </label>
            <ReactSelect
                className={`react-select-input ${className}`}
                onChange={(e) => handleReactSelectChange(e)}
                defaultValue={{
                    value: defaultValue,
                    label: defaultLabel ? defaultLabel : "",
                }}
                options={options}
                unstyled
                id="react-select-input"
                placeholder={"Wpisz lub wybierz z listy"}
                noOptionsMessage={() => "Nie znaleziono opcji"}
                isClearable={false}
                autoFocus={false}
                classNames={{
                    control: (state) => {
                        const borderColor = !state.isFocused
                            ? "border-royalPeriwinkle"
                            : "border-accordorange";

                        return `transition-theme bg-deepIndigo pt-[26px] pb-2 pl-4 pr-12 border-1 rounded ${borderColor} outline-none ring-0 ring-offset-0`;
                    },
                    indicatorSeparator: (state) => {
                        return "hidden";
                    },

                    input: (state) => {
                        return "text-arcticMist text-16 leading-6 tracking-[0.24px] border-0";
                    },
                    placeholder: (state) => {
                        return "text-arcticMist text-16 leading-6 tracking-[0.24px]";
                    },
                    valueContainer: (state) => {
                        return "text-arcticMist text-16 leading-6 tracking-[0.24px]";
                    },
                    menu: (state) => {
                        return "bg-midnightNavy mt-2 shadow-selectShadow border-royalPeriwinkle rounded-[4px]";
                    },
                    dropdownIndicator: (state) => {
                        return "!hidden";
                    },
                    clearIndicator: (state) => {
                        return "text-accordorange cursor-pointer w-[24px] h-[24px] absolute top-1/2 -translate-y-1/2 right-4 [&>svg]:w-[24px] [&>svg]:h-[24px]";
                    },
                    noOptionsMessage: (state) => {
                        return "bg-midnightNavy mt-2 px-4 pt-1 pb-3 shadow-selectShadow border-royalPeriwinkle rounded-[4px] text-arcticMist text-16 leading-6";
                    },
                    option: (state) => {
                        const bgColor = state.isFocused
                            ? "bg-accordorange text-midnightNavy"
                            : "";
                        return ` pl-4 py-3 pr-10 text-arcticMist text-16 leading-6 ${bgColor}`;
                    },
                }}
            />
            <div className="absolute top-1/2 -translate-y-1/2 right-4 pointer-events-none z-10">
                <Icon
                    icon="tabler:chevron-down"
                    width={24}
                    height={24}
                    className="text-royalPeriwinkle"
                />
            </div>
            {questionMark && (
                <div className="absolute -right-8 top-1/2 -translate-y-1/2">
                    <Icon
                        icon={`iconamoon:question-mark-circle`}
                        width={24}
                        height={24}
                        className={`text-arcticMist cursor-pointer transition-theme`}
                    // onMouseEnter={() => setIsShownContextInfo(true)}
                    // onMouseLeave={() => setIsShownContextInfo(false)}
                    />
                </div>
            )}
            {requiredMark && (
                <div className="absolute -right-7 top-5 maxMd:-right-6 text-arcticMist">
                    <Icon
                        icon={`lucide:asterisk`}
                        width={24}
                        height={24}
                        className={`cursor-pointer transition-theme`}
                    />
                </div>
            )}
        </div>
    );
};

export default SelectInput;
